import moment from "moment";
import { token } from "../Actions/AuthAction";

export default function submitModel(data) {
  const jsonToPost = {
    profilepic: data[1].profilePicUrl,
    loginusertoken: token(),
    cityid: data[1].city.value,
    stateid: data[1].state.value,
    pincode: data[1].pincode,
    gender: 2,
    fathersname: data[1].fatherName,
    alternatenumber: data[1].altNumber ? data[1].altNumber : "",
    address: data[1].address,
    projectsDetails: data[3].projectsDetails.map((item) => {
      return {
        projectdescription: item.description,
        propjectname: item.title,
        startdate: item.startMonthYear,
        enddate: item.endMonthYear,
      };
    }),

    educationalDetails: data[2].educationalDetails.map((item) => {
      return {
        qualificationname: item.qualification,
        board: item.uniOrBoard,
        percentage: item.percentage,
        college: item.colOrSch,
        yearofpassing: moment(item.gradMonthYear).format("YYYY"),
        subject: item.course.value,
      };
    }),

    preferredlocation: data[3].preferencelocationDetails.map((item) => {
      return { preferredlocation: item.locationname.value };
    }),
    trainingAndCertificationDetails:
      data[3].trainingAndCertificationDetails.map((item) => {
        return {
          trainingrole: item.courseName,
          trainingdiscription: item.instituteName,
          startdate: item.startMonthYear,
          enddate: item.endMonthYear,
        };
      }),
    skillsDetails: data[3].skillsDetails.map((item) => {
      return { skillsid: item.skillName.value };
    }),
  };
  return jsonToPost;
}
